module.exports = __webpack_public_path__ + "img/tabbar2.c2852884.svg";